export default "__VITE_ASSET__BWqPvBNP__"